import React from 'react'
import Pg7 from '../../../myapp/services/add-money/Pg/Pg7'

function PG7Page() {
  return (
    <Pg7/>
  )
}

export default PG7Page